import { Modal, UserRoleView } from "components";

import { LocationGenerics } from "router/location";
import { useRole } from "hooks/data/use-roles";
import { useSearch } from "react-location";

export default function ViewRoleContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { role, loading: loadingRole } = useRole(
    (searchParams?.id as string) || ""
  );
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loadingRole}
      title="View User Role"
      description="Details of the user role"
    >
      <UserRoleView userRole={role} />
    </Modal>
  );
}
